module.exports = __webpack_public_path__ + "img/Belarus.9e25139f.png";